import React from 'react';
import { Route } from 'react-router-dom';
import { RouteWrapper } from './RouteWrapper';
import { isSubdomain } from '@/utils/subdomainDetection';
import { isAppSubdomain } from '@/utils/domainDetection';
import Index from '@/pages/Index';
import {
  LazyLogin,
  LazySignup,
  LazyMarketplace,
  LazyMarketplaceProperties,
  LazyPropertyDetail,
  LazyAbout,
  LazyJoinTeam,
  LazyFinancing,
} from '@/components/LazyComponents';

// Lazy load recovery and legal pages
const LazyRecuperarSenha = React.lazy(() => import('@/pages/RecuperarSenha'));
const LazyResetPassword = React.lazy(() => import('@/pages/ResetPassword'));
const LazyPrivacidade = React.lazy(() => import('@/pages/Privacidade'));
const LazyTermos = React.lazy(() => import('@/pages/Termos'));
const LazyOnboarding = React.lazy(() => import('@/pages/Onboarding'));
const LazyConfirmEmail = React.lazy(() => import('@/pages/auth/ConfirmEmail'));
const LazyReferralRedirect = React.lazy(() => import('@/pages/ReferralRedirect'));

export const PublicRoutes = () => {
  const isSubdomainPage = isSubdomain();
  const isAppDomain = isAppSubdomain();

  return (
    <>
      {/* Landing page - contexto dependente de subdomínio */}
      <Route
        path="/"
        element={
          isAppDomain ? (
            // app.imobpanda.com/ = página de login
            <RouteWrapper>
              <LazyLogin />
            </RouteWrapper>
          ) : isSubdomainPage ? (
            // tenant.imobpanda.site/ = marketplace
            <RouteWrapper withTenant withMarketing withTenantMarketplace>
              <LazyMarketplace />
            </RouteWrapper>
          ) : (
            // imobpanda.com/ = landing page
            <Index />
          )
        }
      />

      {/* Rota de login alternativa (para compatibilidade) */}
      <Route
        path="/entrar"
        element={
          <RouteWrapper>
            <LazyLogin />
          </RouteWrapper>
        }
      />

      {/* Rota de cadastro */}
      <Route
        path="/cadastra-se"
        element={
          <RouteWrapper>
            <LazySignup />
          </RouteWrapper>
        }
      />

      {/* Rota de cadastro alternativa (para compatibilidade) */}
      <Route
        path="/cadastro"
        element={
          <RouteWrapper>
            <LazySignup />
          </RouteWrapper>
        }
      />

      {/* Rotas de indicação amigáveis (/r/:code ou /ref/:code) */}
      <Route
        path="/r/:code"
        element={
          <RouteWrapper>
            <LazyReferralRedirect />
          </RouteWrapper>
        }
      />
      <Route
        path="/ref/:code"
        element={
          <RouteWrapper>
            <LazyReferralRedirect />
          </RouteWrapper>
        }
      />

      {/* Rota de convite para equipe */}
      <Route
        path="/invite/:token"
        element={
          <RouteWrapper>
            <LazyJoinTeam />
          </RouteWrapper>
        }
      />

      {/* Rota de onboarding */}
      <Route
        path="/onboarding"
        element={
          <RouteWrapper>
            <LazyOnboarding />
          </RouteWrapper>
        }
      />

      {/* Rota de confirmação de email */}
      <Route
        path="/auth/confirm"
        element={
          <RouteWrapper>
            <LazyConfirmEmail />
          </RouteWrapper>
        }
      />

      <Route
        path="/recuperar-senha"
        element={
          <RouteWrapper>
            <LazyRecuperarSenha />
          </RouteWrapper>
        }
      />

      <Route
        path="/redefinir-senha"
        element={
          <RouteWrapper>
            <LazyResetPassword />
          </RouteWrapper>
        }
      />

      <Route
        path="/privacidade"
        element={
          <RouteWrapper>
            <LazyPrivacidade />
          </RouteWrapper>
        }
      />

      <Route
        path="/termos"
        element={
          <RouteWrapper>
            <LazyTermos />
          </RouteWrapper>
        }
      />

      {/* Rotas de propriedades - APENAS em subdomínios de tenant */}
      {isSubdomainPage && !isAppDomain && (
        <>
          <Route
            path="/properties"
            element={
              <RouteWrapper withTenant withMarketing withTenantMarketplace>
                <LazyMarketplaceProperties />
              </RouteWrapper>
            }
          />

          <Route
            path="/imovel/:id"
            element={
              <RouteWrapper withTenant withMarketing withTenantMarketplace>
                <LazyPropertyDetail />
              </RouteWrapper>
            }
          />

          <Route
            path="/financiamento"
            element={
              <RouteWrapper withTenant withMarketing withTenantMarketplace>
                <LazyFinancing />
              </RouteWrapper>
            }
          />

        </>
      )}
    </>
  );
};

